import common from "./common.json";
import validations from "./validations.json";

export default {
	common,
	validations,
};
